import { createFileRoute } from "@tanstack/react-router";
import { GeneralDonationCheckout } from "@project/donate/pages/checkout/$kind.$id";

export const Route = createFileRoute("/donate/general")({
  head: () => ({
    meta: [
      { title: "General Donation — Jivandhara" },
      {
        name: "description",
        content:
          "Make a general donation to Jivandhara and support elder care, food and medical seva. 80G receipt available.",
      },
    ],
  }),
  component: GeneralDonationCheckout,
});
